export default "/images/vendor/flag-icon-css/flags/1x1/nl.svg?c0bdb1a8a77eb133c4b7b4d4391d5ad4";